import * as React from 'react';
import { useTranslation } from 'react-i18next';
import T from 'aegisv2/Text';
// import AccentButton from 'Jsx/Shared/CustomAegisComponents/AccentButton';
import AccentButton from 'aegisv2/Buttons/AccentButton';
import styled from 'styled-components';
import { CATALOG_TRANSLATION_KEY } from 'Jsx/Utils/transformKeys';
const strings = {
  title: 'Ten acceso total con Premium',
  subTitle:
    'Únete a nuestra comunidad Premium y accede a +500 cursos y +9 carreras.',
  buttonLabel: 'Me interesa',
};

const Wrapper = styled.div`
  background-color: #1f2136;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 36px;
  margin-bottom: 80px !important;
  margin-top: 80px !important;
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .title {
    font-size: 32px;
    line-height: 36px;
    margin-bottom: 14px;
  }
  .mainButton {
    margin-top: 20px;
    width: fit-content;
    padding: 14px 32px;
  }
  @media (min-width: 768px) {
    padding: 80px 36px;
    .title {
      line-height: 40px;
      margin-bottom: 8px;
    }
  }
`;

const MembershipCta = ({ countryPrefix }) => {
  const { t } = useTranslation(CATALOG_TRANSLATION_KEY);

  return (
    <Wrapper>
      <div className="content">
        <T
          white
          bold
          className="title"
          style={{ fontFamily: 'Gilroy, Arial, sans-serif' }}
        >
          {t('COURSE_MEMBERSHIP_TITLE')}
        </T>
        <T white>{t('COURSE_MEMBERSHIP_SUBTITLE')}</T>
        <AccentButton
          className="mainButton"
          label={t('COURSE_MEMBERSHIP_BUTTON')}
          onClick={() => {
            window.location.href = countryPrefix
              ? `/${countryPrefix}/membresias/`
              : '/membresias/';
          }}
        />
      </div>
    </Wrapper>
  );
};

export default MembershipCta;
